import { useTQC2060_R01Store } from "./Store_TQC2060_R01";
import { ImageForm } from "src/components/common/form/ImageForm";
import { defaultTQC2060_R01HdrDto } from "./Dto_TQC2060_R01";

export const Images_TQC2060_R01 = () => {
	const { editTQC2060_R01, setEditTQC2060_R01 } = useTQC2060_R01Store();

	const imageWrapperStyle = {
		wrapperStyle: "w-[260px] h-[260px]",
	};

	return (
		<div className="w-full h-full flex flex-row gap-4">
			<div className="flex-1">
				<ImageForm 
					title="시험 전 사진" 
					image={editTQC2060_R01?.beforeImage || ''} 
					onImageChange={(beforeImage) => setEditTQC2060_R01({ ...(editTQC2060_R01 ?? defaultTQC2060_R01HdrDto), beforeImage })}
					wrapperOption={imageWrapperStyle} 
				/>
			</div>
			<div className="flex-1">
				<ImageForm 
					title="시험 후 사진" 
					image={editTQC2060_R01?.afterImage || ''} 
					onImageChange={(afterImage) => setEditTQC2060_R01({ ...(editTQC2060_R01 ?? defaultTQC2060_R01HdrDto), afterImage })}
					wrapperOption={imageWrapperStyle} 
				/>
			</div>
		</div>
	);
};

